import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { Condition, ConditionData, ConditionHelper, ConditionProviders } from "./condition";

export interface UICondition extends Condition {
    imageName: string;
}

export interface UIConditionData extends ConditionData {
    imageName: string;
}

export class UIConditionHelper extends ConditionHelper {
    conditionType = "UICondition";
    static SCENE_IMAGE_PATH = "assets/images/scene-icons/";
    static SVG_EXTENSION = ".svg";
    static isValid(condition: UICondition): boolean {
        return !!condition.imageName;
    }

    static readonly importMap: ImportMap<UICondition, UIConditionData> = [
        { i: "name", o: "name" },
        { i: "condition_id", o: "conditionId" },
        { i: "condition_type", o: "conditionType" },
        { i: "imageName", o: "imageName" },
    ];

    static fromCHObject(condition): UICondition {
        return {
            name: condition[this.importMap[0].i],
            conditionId: condition[this.importMap[1].i],
            conditionType: condition[this.importMap[2].i],
            imageName: condition[this.importMap[3].i],
        };
    }

    static getDefault(): UICondition {
        return {
            name: "UI Condition",
            conditionId: null,
            conditionType: ConditionProviders.UI_CONDITION,
            imageName: null,
        };
    }
}
